import { walletMap } from '@blink/components/src/constants/wallet';
import { WALLET } from '@blink/components/src/types';
import { WalletConnect } from '@blink/components/src/utils/wallet/walletConnect';
import { AbstractWallet } from '@blink/components/src/utils';

import { getFeatureFlag } from '@/shared/utils/getFeatureFlag';
import { NewWalletConnect } from '@/shared/utils/walletConnect';
import { Features } from '@/shared/configs/features';

let updatedWalletMap: Map<WALLET, AbstractWallet> | null = null;

export const getWalletMap = () => {
    const isNewWalletConnect = getFeatureFlag(Features.NewWalletConnect, true);

    if (updatedWalletMap) {
        return updatedWalletMap;
    }

    walletMap.set(
        WALLET.WALLET_CONNECT,
        isNewWalletConnect ? new NewWalletConnect() : new WalletConnect(),
    );

    updatedWalletMap = walletMap;

    return updatedWalletMap;
};
